import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFolder = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "3.2 3.2 41.6 41.6",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M6.85 40.8q-1.436 0-2.543-1.116T3.2 37.15v-26.3q0-1.418 1.107-2.534T6.85 7.2H20.4l3.65 3.65h17.1q1.418 0 2.534 1.116T44.8 14.5v22.65q0 1.418-1.116 2.534T41.15 40.8z" })
});
export default SvgFolder;
